/* 
Displays the passed payment data in a box
*/
import { Text, Stack, Group } from "@mantine/core";
import web3 from "web3";
import "./hover.css";

export default function PaymentBox(props) {
  if (!props.paymentInfo) {
    return <Text>...</Text>;
  }
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  let date = null;
  if (props.paymentInfo.timestamp) {
    date = new Date(props.paymentInfo.timestamp * 1000).toLocaleString();
  }
  if (props.paymentInfo.gas) {
    // TODO: display gas spent?
  }
  return (
    <Stack spacing={12}>
      <Group spacing={12} position="center">
        {date ? <Text>{date}</Text> : ""}
        <Text
          className="hoverText"
          onClick={() =>
            openInNewTab("https://arbiscan.io/tx/0x" + props.paymentInfo.txHash)
          }
        >
          {parseFloat(
            web3.utils.fromWei(props.paymentInfo.amount.toString(), "ether") ||
              0
          ).toFixed(8)}{" "}
          Eth earned
        </Text>
      </Group>
    </Stack>
  );
}
